import React, { useEffect, useState } from 'react';
import './questions.css';

const destination = "backend.rethinkpack.com";

const CommonQuestions = () => {
    const [questions, setQuestions] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchCommonQuestions = async () => {
            try {
                const response = await fetch(`https://${destination}/api/displayQuestions`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                // Filter only questions where selectedCategory is 'general'
                console.log("Fetched data:", data);
                const generalQuestions = data.filter(question => {
                    console.log("Question item:", question); // Log each question
                    return question.selectedCategory === 'general';
                });
                                setQuestions(generalQuestions);
            } catch (error) {
                console.error("Error fetching questions:", error);
                setError(error);
            }
        };

        fetchCommonQuestions();
    }, []);

    if (error) {
        return <div>Error: {error.message}</div>;
    }

    if (!questions.length) {
        return <div>No General Questions available</div>;
    }

    return (
        <div className="questions-container">
            {questions.map((question, index) => (
                <div key={index} className="question-card">
                    <h4>{question.question}</h4>
                    {question.options && question.options.map((option, optIndex) => (
                        <div key={optIndex}>{option.text}</div>
                    ))}
                </div>
            ))}
        </div>
    );
};

export default CommonQuestions;
